import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select} from 'antd'
import _ from 'lodash'
import Request from '../../request'
import {connect} from 'react-redux'
import StaffLeaveAction from '../../components/_utils/staffLeaveAction.js'
import moment from 'moment'
import AddStaffLeave from '../../components/_utils/addStaffLeave';
import { RightsWrapper } from '../../components/_utils/utils'



const {MonthPicker, RangePicker} = DatePicker
const Option = Select.Option;
@Form.create()
class TeamLeaves extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month:null,
        activityArr: [],
        oldLeaves:[],
        record:{},
        allUsers:[],
        userId:null,
        showLeaveActionForm:false,
        showLeaveAddForm:false,
        filterYear:'',
        leaveType:'',
        years:['2023', '2024'],
        leaveTypes:['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'LWN(Leave Without Notice)', 'HD(Half Day)', 'Sandwich Leave', 'WFH(Work From Home)']
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleStaffLeaveApplication = (record) =>{
        this.setState({showLeaveActionForm:true, record:record})
    }

    handleStaffLeaveApplicationClose = () =>{
        this.setState({showLeaveActionForm:false, record:{}})
        this.table.current.reload()
    }

    handleAdd=()=>{
        this.setState({showLeaveAddForm:true})
    }

    handleClose = () =>{
        this.setState({showLeaveAddForm:false})
        this.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            if(this.state.filterYear) {
                params.leaveYear = this.state.filterYear
            }
            if(this.state.month) {
                params.month = this.state.month
            }
            if(this.state.userId) {
                params.userId = this.state.userId
            }
            if(this.state.leaveType) {
                params.leaveType = this.state.leaveType
            }
            let response = await Request.getTeamLeaveApplications(params)
            this.setState({count:response.total})
            resolve(response)
        })
    }

    handleMonthChange = (month,dateString) =>{
        if(month === null) {
            this.setState({month:null})
            this.reload()
        }else {
            this.setState({month:moment(month)}, ()=>{
                this.reload()
            })
        }
        
    }

    async componentDidMount() {
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"},
        };
        let activeUser = JSON.parse(localStorage.getItem('user'))
        params.userBranch = activeUser.userBranch
        let response = await Request.loadUser({...params, regExFilters: ['name']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize, showLeaveActionForm, years,leaveTypes, count, record, allUsers, showLeaveAddForm} = this.state
        const columns = [
            {
                title:'Employee Name',
                key:'employeeName',
                fixed:true,
            },
            {
                title: 'Start Date',
                key: 'startDate',
            },
            {
                title: 'Start Time',
                key: 'startTime',
            },
            {
                title: 'End Date',
                key: 'endDate',
            },
            {
                title:'End Time',
                key:'endTime',
            },
            {
                title:'Leave Duration',
                key:'leaveDuration',
                render:(text,record) => (
                    <div>
                        {record.leaveDuration?record.leaveDuration >1?<span>{text} Days</span>:<span>{text} Day</span>:null}
                    </div>
                )
            },
            {
                title:'Last Leave Taken',
                key:'lastLeaveTaken',
            },
            {
                title:'Leave Type',
                key:'leaveType',
            },
            {
                title:'Asset Details',
                key:'assetDetails',
            },
            {
                title:'Leave Reason',
                key:'leaveReason'
            },
            {
                title:'Emergency Task Going On',
                key:'isEmergencyTaskGoingOn',
            },
            {
                title:'Approved/Disapproved By',
                key:'updatedByUser.name',
                render:(text,record)=>{
                    if(record.status === "Approved" || record.status === "Disapproved") {
                        return (
                            <div>{record.updatedByUser && record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title:'Status',
                key:'status'
            },
            {
                title:'Action',
                key:'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <React.Fragment>
                    <Tooltip title="Action">
                      <Button
                        size={"small"}
                        shape="circle"
                        onClick={() => this.handleStaffLeaveApplication(record)}
                        icon="forward"
                      />
                    </Tooltip>&nbsp;
                  </React.Fragment>
                ),
            }
        ]


    return (
        <PageHeaderWrapper title={`Staff Leave Applications:- ${count}` }>
            {
                showLeaveActionForm?
                <StaffLeaveAction record={record} onClose={this.handleStaffLeaveApplicationClose} />
                :null
            }
            {
                showLeaveAddForm?
                <AddStaffLeave users={allUsers} onClose={this.handleClose} />
                :null
            }
            <Card bordered={true}>
                <Row style={{display:'flex'}}>
                    <Col span={6}>
                        <label>Search By Month</label><br />
                        <MonthPicker style={{maxWidth: '90%'}} placeholder='Select Month' format="YYYY-MM" onChange={this.handleMonthChange} />
                    </Col>
                    <Col span={4}>
                    <label>Search By Year</label><br />
                        <Select
                        allowClear
                        showSearch={true}
                        value={this.state.filterYear}
                    placeholder="Select Year"
                    style={{width: '90%'}}
                    onChange={filterYear => {
                        this.setState({filterYear}, () => {
                            setTimeout(() => {
                                this.reload()
                            }, 500);
                        })
                    }}>
                        {
                            years && years.map((year,index)=>{
                                return (
                                    <Option key={index} value={year}>
                                        {year}
                                    </Option>
                                )
                            })
                        }
                         </Select>
                    </Col>
                    <Col span={5}>
                        <label>Search By Leave Type</label>
                        <Select
                            allowClear
                            showSearch={true}
                            placeholder="Select Leave Type"
                            style={{width:'90%'}}
                            onChange={leaveType => {
                                this.setState({leaveType}, ()=>{
                                    setTimeout(()=>{
                                        this.reload()
                                    },500)
                                })
                            }}>
                            {
                                leaveTypes.map((leave,index)=>{
                                    return (
                                        <Option key={index} value={leave}>{leave}</Option>
                                    )
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={5}>
                        <label>Search by User</label>
                        <Select 
                            allowClear
                            showSearch={true}
                            style={{width: '90%'}}
                            value={this.state.userId}
                            placeholder="Select Option"
                            optionFilterProp="name"
                            onChange={userId => {
                                this.setState(
                                    {
                                      userId: userId && userId.toString()
                                    },
                                    () => {
                                        setTimeout(() => {
                                            this.reload()
                                        }, 500);
                                    }
                                );
                            }}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                        {
                            allUsers.map((val,idn)=>{
                                return(
                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                )
                            })
                        }

                        </Select>
                    </Col>
                    <RightsWrapper myRight={'StaffLeaves.add'}>
                    <Col span={2}>
                        <div style={{ marginTop: '15px'}}>
                            <Button onClick={()=>this.handleAdd()}>Add</Button>
                        </div>
                    </Col>
                    </RightsWrapper>
                </Row>
            </Card>
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    extraProps={{scroll: {x: 1550}}}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamLeaves)
